import he from 'he';
import { APIDialogModel } from '../types/api';

export const parseDialogLastMessage = (lastMessage: string | null) => {
  const splittedData = lastMessage?.split(':');

  if (splittedData?.length === 1) {
    return {
      userFullName: null,
      userLastMessage: he.decode(splittedData[0]),
    };
  }

  return {
    userFullName: splittedData?.[0] || '',
    userLastMessage: he.decode(splittedData?.[1] || ''),
  };
};

export const isCustomerMessageRead = (
  dialog: APIDialogModel,
  currentUserId = '',
) => (dialog?.readCustomerIds || []).includes(currentUserId);

export const hasUnreadCustomerMessage = (
  items: APIDialogModel[],
  currentUserId = '',
) => items.some((it) => !isCustomerMessageRead(it, currentUserId));

export const hasUnreadDispatcherMessage = (items: APIDialogModel[]) =>
  items.some((it) => !it.isReadByDispatcher);
